<template>
  <a-space>
    <a v-if="showEdit" @click="goto(editUrl + '/edit/' + id)" v-perm="editPerm">
      <a-button>编辑</a-button>
    </a>
    <a v-if="showChange" @click="goto(`${editUrl}/edit/${id}?isChange=true`)" v-perm="editPerm">
      <a-button>变更</a-button>
    </a>
    <a-button type="primary" @click="submit()" v-if="permissionsFn('submit')">提交审批</a-button>
    <a-button type="primary" @click="agree()" v-if="permissionsFn('agree')">同意</a-button>
    <a-button type="primary" danger @click="reject()" v-if="permissionsFn('agree')">拒绝</a-button>
    <a-button @click="cancel" v-if="permissionsFn('cancel')">撤销</a-button>
    <a-button type="primary" danger @click="voidAction()" v-if="permissionsFn('void')"
      >作废</a-button
    >
    <a-button type="primary" danger @click="deleteAction()" v-if="permissionsFn('delete')"
      >删除</a-button
    >
    <a-button type="primary" v-if="permissionsFn('recycle')" @click="recycleAction()"
      >恢复</a-button
    >
    <a-button
      type="primary"
      danger
      v-if="permissionsFn('completelyDelete')"
      @click="deleteCompleteRow()"
      >彻底删除</a-button
    >
  </a-space>
  <a-modal
    :confirmLoading="loading"
    :centered="true"
    v-model:visible="visible"
    @ok="handleOk(currentAction)"
    class="flow-model"
    :bodyStyle="{minHeight: '100px'}"
  >
    <template #title>
      <h4 class="flow-model-title">{{ modelMap.get(currentAction)?.title }}</h4>
      <span class="flow-model-subtitle">{{ modelMap.get(currentAction)?.subtitle }}</span>
    </template>
    <div class="flow-model__subtitle mt14" v-if="currentAction == 'delete'">
      当前审批状态：{{ record?.flowStatusName }}
    </div>
    <div class="flow-model__subtitle" v-if="currentAction == 'delete'">删除原因</div>
    <a-textarea
      show-count
      v-model:value="approvalContent"
      :placeholder="'请输入' + modelMap.get(currentAction)?.title + '，最多200字'"
      :auto-size="{ minRows: 3 }"
      :maxlength="200"
      allowClear
    />
  </a-modal>
</template>
<script lang="ts">
import {
  type Ref,
  computed,
  defineComponent,
  ref,
  toRefs,
  reactive,
  PropType,
  createVNode,
} from "vue";
import { useFlowHandle } from "../table-flow-btn/useFlowHandle";
import { TabService } from "@/core";
import { Modal, message } from "ant-design-vue";
import { getCurrentUserId } from "@/utils";
import { VoidBtnModuleArr, changeBtnModuleArr } from "../table-flow-btn/flow-btn.constant";
import { ExclamationCircleOutlined } from "@ant-design/icons-vue";
import { useStore } from "@/store";
import { useRouter,useRoute } from "vue-router";
import { tabListArr } from "@/views/project/profile/project-view/view-constant";
export default defineComponent({
  isGlobal: true,
  name: "DetailBtns",
  props: {
    bizId: {
      type: String,
    },
    bizIdKey: {
      //对应id key值
      type: String,
      default: "id",
    },
    bizType: {
      type: String,
      required: true,
    },
    record: {
      type: Object as PropType<any>,
    },
    // 接口需要 对应name的值
    bizName: {
      type: String,
      default: "name",
    },
    // 接口需要 对应name的key值，为了工作台展示
    bizNameKey: {
      type: String,
      default: "name",
    },
    // 接口需要 对应name的key值，为了工作台展示
    statusKey: {
      type: String,
      default: "status",
    },
    examineAccess: {
      //流程
      type: String,
      default: "",
    },
    recoverAccess: {
      //恢复
      type: String,
      default: "",
    },
    completelyDeleteAccess: {
      //彻底删除
      type: String,
      default: "",
    },
    deleteAccess: {
      //删除
      type: String,
      default: "",
    },
    url: {
      type: String,
      default: "",
    },
    editUrl: {
      type: String,
      default: "",
    },
    editPerm: {
      type: String,
      default: "",
    },
    changePerm: {
      type: String,
      default: "",
    },
    other: {
      type: Function,
    },
  },
  emits: ["refresh"],
  setup(props, { emit, slots }) {
    const store = useStore();
    const router = useRouter();
    const route = useRoute();
    const state = reactive(<
      {
        approvalContent: string;
        loading: boolean;
        visible: boolean;
        currentUserId: string;
        modelMap: Map<String, { title: string; action: string; subtitle: string }>;
        currentAction: string;
        id: any;
      }
    >{
      approvalContent: "",
      loading: false,
      visible: false,
      currentUserId: getCurrentUserId(),
      modelMap: new Map([
        ["delete", { title: "删除", action: "删除" }],
        ["agree", { title: "添加审批意见", action: "同意", subtitle: "当前操作：同意" }],
        ["reject", { title: "添加审批意见", action: "拒绝", subtitle: "当前操作：拒绝" }],
        ["void", { title: "添加作废原因", action: "作废（必填）", subtitle: "当前操作：作废" }],
      ]),
      currentAction: "",
      id: computed(() => {
        const t = props.url.split("/");
        let tmp = t[t.length - 1];
        if (tmp && tmp.indexOf("?")) {
          tmp = tmp.split("?")[0];
        }
        return tmp;
      }),
    });
    const {
      submitBtn,
      cancelBtn,
      voidBtn,
      agreeBtn,
      rejectBtn,
      deleteCompleteBtn,
      visibleBtnByStatus,
      recycleBtn,
      deleteBtn,
    } = useFlowHandle();
    const showEdit = computed(() => {
      return (
        visibleBtnByStatus(
          props.bizType,
          props.record[props.statusKey],
          props.other,
          props.record
        ) &&
        !!store.state.user.buttons[props.editPerm] &&
        0 === props.record?.isRecycled &&
        state.currentUserId === props.record?.createBy &&
        (props.record?.flowStatus == "dtj" ||
          props.record?.flowStatus === "ycx" ||
          props.record?.flowStatus === "spbtg")
      );
    });
    const showChange = computed(() => {
      return (
        changeBtnModuleArr.includes(props.bizType) &&
        !!store.state.user.buttons[props.changePerm] &&
        0 === props.record?.isRecycled &&
        props.record?.flowStatus == "sptg"
      );
    });
    //  state.currentUserId === props.record?.createBy &&

    const permissionsFn = (type) => {
      let isShow = false;
      switch (type) {
        case "submit":
          isShow =
            visibleBtnByStatus(
              props.bizType,
              props.record[props.statusKey],
              props.other,
              props.record
            ) &&
            !!store.state.user.buttons[props.examineAccess] &&
            state.currentUserId === props.record?.createBy &&
            0 === props.record?.isRecycled &&
            (props.record?.flowStatus == "dtj" ||
              props.record?.flowStatus === "ycx" ||
              props.record?.flowStatus === "spbtg");

          break;
        case "agree":
          isShow =
            visibleBtnByStatus(
              props.bizType,
              props.record[props.statusKey],
              props.other,
              props.record
            ) &&
            !!store.state.user.buttons[props.examineAccess] &&
            0 === props.record?.isRecycled &&
            props.record?.auditUsers?.includes(state.currentUserId) &&
            props.record?.flowStatus == "spz";
          break;

        case "cancel":
          isShow =
            visibleBtnByStatus(
              props.bizType,
              props.record[props.statusKey],
              props.other,
              props.record
            ) &&
            !!store.state.user.buttons[props.examineAccess] &&
            0 === props.record?.isRecycled &&
            state.currentUserId === props.record?.createBy &&
            props.record?.flowStatus == "spz" &&
            props.record?.isChanging != 1;
          break;
        case "void":
          isShow =
            visibleBtnByStatus(
              props.bizType,
              props.record[props.statusKey],
              props.other,
              props.record
            ) &&
            !!store.state.user.buttons[props.examineAccess] &&
            state.currentUserId === props.record?.createBy &&
            0 === props.record?.isRecycled &&
            props.record["validStatus"] &&
            props.record["validStatus"] != "yzf" &&
            props.record?.flowStatus == "sptg" &&
            VoidBtnModuleArr.includes(props.bizType);
          break;
        case "delete":
          isShow =
            !!store.state.user.buttons[props.deleteAccess] &&
            state.currentUserId === props.record?.createBy &&
            0 === props.record?.isRecycled &&
            (props.record?.flowStatus == "dtj" || props.record?.flowStatus === "ycx");
          break;
        case "recycle":
          isShow =
            !!store.state.user.buttons[props.recoverAccess] &&
            state.currentUserId === props.record?.createBy &&
            props.record?.isRecycled == 1;
          break;
        case "completelyDelete":
          isShow =
            !!store.state.user.buttons[props.completelyDeleteAccess] &&
            state.currentUserId === props.record?.createBy &&
            props.record?.isRecycled == 1;
          break;
        default:
          break;
      }
      return isShow;
    };
    const submit = async () => {
      // 竣工验收
      // console.log("🚀 ~ submit ~ props.bizType:", props.bizType);
      if (props.bizType == "completion_acceptance_examine") {
        Modal.confirm({
          title: "提示",
          icon: createVNode(ExclamationCircleOutlined),
          content: "竣工验收会导致整个项目流程完结，请谨慎操作！",
          okText: "确定",
          okType: "primary",
          cancelText: "取消",
         async onOk() {
            await submitBtn(
          props.bizId || props.record[props.bizIdKey],
          props.bizType,
          props.bizName || props.record[props.bizNameKey]
        );
        refresh();
          },
          onCancel() {
            // console.log("Cancel");
          },
        });
      } else {
        await submitBtn(
          props.bizId || props.record[props.bizIdKey],
          props.bizType,
          props.bizName || props.record[props.bizNameKey]
        );
        refresh();
      }
    };
    const agree = () => {
      state.currentAction = "agree";
      // // console.log(
      //   "🚀 ~ file: index.vue:134 ~ agree ~ state.modelMap.get('agree'):",
      //   state.modelMap.get("agree")
      // );
      state.approvalContent = "";
      state.visible = true;
    };
    const reject = () => {
      state.currentAction = "reject";

      state.approvalContent = "";
      state.visible = true;
    };
    const voidAction = () => {
      state.currentAction = "void";

      state.approvalContent = "";
      state.visible = true;
    };
    const deleteAction = () => {
      state.currentAction = "delete";

      state.approvalContent = "";
      state.visible = true;
    };
    const recycleAction = async () => {
      await recycleBtn(props.record.id, props.bizType);
      refresh();
      // Modal.confirm({
      //   title: "正在进行恢复操作, 是否继续?",
      //   icon: createVNode(ExclamationCircleOutlined),
      //   content: "请谨慎操作！",
      //   okText: "确定",
      //   centered:true,
      //   okType: "primary",
      //   cancelText: "取消",
      //   onOk: async () => {
      //     await recycleBtn(props.record.id, props.bizType);
      //     refresh();
      //   },
      //   onCancel() {
      //     // console.log("Cancel");
      //   },
      // });
    };
    const cancel = async () => {
      Modal.confirm({
        title: "提示",
        icon: createVNode(ExclamationCircleOutlined),
        content: "确定执行撤销？",
        okText: "确定",
        okType: "primary",
        centered: true,
        cancelText: "取消",
        onOk: async () => {
          await cancelBtn(props.bizId || props.record[props.bizIdKey], props.bizType);
          refresh();
        },
        onCancel() {
          // console.log("Cancel");
        },
      });
    };
    const handleOk = async (type) => {
      switch (type) {
        case "agree":
          await handleAgreeOk();
          break;
        case "delete":
          await handleDeleteOk();
          break;
        case "reject":
          await handleRejectOk();
          break;
        case "void":
          await handleVoidOk();
          break;

        default:
          break;
      }
    };
    const handleDeleteOk = async () => {
      // await agreeBtn(
      //   props.bizId || props.record[props.bizIdKey],
      //   props.bizType,
      //   props.record[props.bizNameKey],
      //   state.approvalContent
      // );
      if (!state.approvalContent) {
        message.warning("请填写删除原因");
        return;
      }
      state.loading = true;
      await deleteBtn(
        props.bizId || props.record[props.bizIdKey],
        props.bizType,
        state.approvalContent
      );
      state.loading = false;

      refresh();

      state.visible = false;
      if(window.self!== window.top){//如果是在iframe中
        let tabObj= tabListArr.find((item)=>{
           return item.key==route.query['iframeKey']}
           );
           if(tabObj&&tabObj.hasOwnProperty('id')){
             router.push('/project/general-add?addPath='+tabObj.addPath+'&detailPath='+tabObj.path+'&projectId='+route.query['projectId']+'&projectName='+route.query['projectName']+'&iframeKey='+tabObj.key)
           }else if(tabObj){
            router.push(tabObj.path+'?projectId='+route.query['projectId']+'&projectName='+route.query['projectName']+'&iframeKey='+tabObj.key)
           }else{
             router.back();
           }
      }else{
        router.back();
      }
      // router.back();
    };
    const handleAgreeOk = async () => {
      state.loading = true;
      await agreeBtn(
        props.bizId || props.record[props.bizIdKey],
        props.bizType,
        props.bizName || props.record[props.bizNameKey],
        state.approvalContent
      );
      state.loading = false;

      state.visible = false;
      refresh();
    };
    const handleRejectOk = async () => {
      state.loading = true;
      await rejectBtn(
        props.bizId || props.record[props.bizIdKey],
        props.bizType,
        props.bizName || props.record[props.bizNameKey],
        state.approvalContent
      );
      state.loading = false;

      state.visible = false;
      refresh();
    };
    const handleVoidOk = async () => {
      if (!state.approvalContent) {
        message.warning("请填写作废原因");
        return;
      }
      state.loading = true;
      await voidBtn(
        props.bizId || props.record[props.bizIdKey],
        props.bizType,
        props.bizName || props.record[props.bizNameKey],
        state.approvalContent,
        false
      );
      state.loading = false;

      state.visible = false;
      
      if(window.self!== window.top){//如果是在iframe中
        let tabObj= tabListArr.find((item)=>{
           return item.key==route.query['iframeKey']}
           );
           if(tabObj&&tabObj.hasOwnProperty('id')){
             router.push('/project/general-add?addPath='+tabObj.addPath+'&detailPath='+tabObj.path+'&projectId='+route.query['projectId']+'&projectName='+route.query['projectName']+'&iframeKey='+tabObj.key)
           }else if(tabObj){
            router.push(tabObj.path+'?projectId='+route.query['projectId']+'&projectName='+route.query['projectName']+'&iframeKey='+tabObj.key)
           }else{
            refresh();
           }
      }else{
        refresh();
      }
    };
    const deleteCompleteRow = async () => {
      Modal.confirm({
        title: "警告",
        icon: createVNode(ExclamationCircleOutlined),
        content: "彻底删除后将无法恢复，请谨慎操作！",
        okText: "确定",
        centered: true,
        cancelText: "取消",
        onOk: async () => {
          await deleteCompleteBtn([props.record.id], props.bizType);
          TabService.closeCurrentTab();
          router.back();
        },
        onCancel() {
          // console.log("Cancel");
        },
      });
    };
    const refresh = () => {
      emit("refresh");
    };
    const goto = (url) => {
      router.push(url);
      if (window.self !== window.top) {
         window.parent.postMessage({ type: 'setShowCard', data: false }, '*');
      }
    }
    return {
      ...toRefs(state),
      goto,
      submit,
      handleAgreeOk,
      agree,
      reject,
      handleRejectOk,
      cancel,
      voidAction,
      handleVoidOk,
      permissionsFn,
      handleOk,
      deleteAction,
      deleteCompleteRow,
      showEdit,
      recycleAction,
      showChange,
    };
  },
});
</script>
<style scoped lang="less">
.flow-model-title {
  margin-bottom: 0;
  font-weight: 600;

  display: inline-block;
}
.flow-model__subtitle {
}
.mt14 {
  margin-top: -14px;
}
.flow-model-subtitle {
  font-size: 14px;
  padding-left: 10px;
}
:deep(.flow-model){
  min-height: 216px;
}
</style>
